import * as React from "react";
import {
  ExperimentProvider as DivvyExperimentProvider,
  ExperimentProviderContext,
} from "@carvana/experiment";
import { createRegisteredContext, getContext } from "react-singleton-context";
import { useFlags } from "launchdarkly-react-client-sdk";

type ExperimentProviderContextValue = React.ComponentProps<
  typeof ExperimentProviderContext.Provider
>["value"];

export type ContextValue = ExperimentProviderContextValue | undefined;

export const ExperimentContext = createRegisteredContext<
  ContextValue | undefined
>("ExperimentContext", undefined);

type Props = React.ComponentProps<typeof DivvyExperimentProvider>;

export function ExperimentProvider({ children, ...rest }: Props) {
  return (
    <DivvyExperimentProvider {...rest}>
      <ExperimentProviderContext.Consumer>
        {(experimentValue) => (
          <ExperimentContext.Provider value={experimentValue}>
            {children}
          </ExperimentContext.Provider>
        )}
      </ExperimentProviderContext.Consumer>
    </DivvyExperimentProvider>
  );
}

export function useExperimentBucket(bucketName: string): string | null {
  const contextValue = React.useContext(getContext(ExperimentContext));

  return contextValue?.experiments[bucketName]?.assignedBucket ?? null;
}

export function useExperimentBuckets() {
  const { auctionEnabledExperiments = [] } = useFlags<{
    auctionEnabledExperiments: string[] | undefined;
  }>();
  const contextValue = React.useContext(getContext(ExperimentContext));

  const buckets: { [key: string]: string } = {};
  for (const experiment of auctionEnabledExperiments) {
    const bucket =
      contextValue?.experiments[experiment]?.assignedBucket ?? null;
    if (bucket) {
      buckets[experiment] = bucket;
    }
  }
  return buckets;
}
